import { useQuery } from "react-query";
import { axiosInstance } from "../../../../utils/axiosInstance";

export const useGetBookingsQuery = ({ status }: { status: string }) => {
  const token = localStorage.getItem("W2ST_STUDENT_TOKEN");

  return useQuery({
    queryKey: ["getBookingsQuery", status],
    queryFn: async () => {
      if (!token) throw new Error("Authorization token is missing");

      const config: any = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };

      if (status !== "") {
        config.params = { status };
      }

      const response = await axiosInstance.get(`users/bookings`, config);

      return response.data;
    },
    onSuccess: (data) => {},
    onError: (error: unknown) => {},
    enabled: !!token,
  });
};
